var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.960693H513V342.927H0V0.960693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 216.581H211.913V342.927H0V216.581Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.960693H211.913V127.407H0V0.960693Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.087 0.960693H513V127.407H301.087V0.960693Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.087 216.581H513V342.927H301.087V216.581Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 131.215H206.503V180.711C206.503 180.711 226.041 186.723 256.5 186.723V131.215Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.003 128.715H259V189.223H256.5C241.107 189.223 228.464 187.704 219.653 186.18C215.247 185.419 211.797 184.655 209.438 184.079C208.259 183.791 207.352 183.55 206.735 183.379C206.426 183.293 206.189 183.225 206.028 183.178C205.947 183.154 205.884 183.136 205.841 183.123L205.79 183.107L205.775 183.103L205.769 183.101C205.768 183.101 205.767 183.101 206.503 180.711L205.767 183.101L204.003 182.558V128.715ZM209.003 178.812C209.458 178.931 210 179.069 210.624 179.222C212.881 179.773 216.219 180.512 220.505 181.253C228.599 182.653 240.064 184.057 254 184.209V133.715H209.003V178.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.503 180.711V186.723C206.503 214.276 228.846 236.72 256.5 236.72V186.723C226.041 186.723 206.503 180.711 206.503 180.711Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.003 183.972V186.723C209.003 212.063 228.896 232.854 254 234.156V189.209C239.736 189.057 227.982 187.621 219.653 186.18C215.247 185.419 211.797 184.655 209.438 184.079C209.289 184.042 209.143 184.007 209.003 183.972ZM207.238 178.322L207.244 178.323L207.278 178.334C207.311 178.344 207.362 178.359 207.431 178.379C207.57 178.42 207.784 178.481 208.069 178.56C208.639 178.718 209.496 178.946 210.624 179.222C212.881 179.773 216.219 180.512 220.505 181.253C229.078 182.736 241.433 184.223 256.5 184.223H259V239.22H256.5C227.462 239.22 204.003 215.654 204.003 186.723V177.326L207.238 178.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 236.72C284.054 236.72 306.497 214.377 306.497 186.723V180.711C306.497 180.711 286.959 186.723 256.5 186.723V236.72Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.997 177.326V186.723C308.997 215.761 285.431 239.22 256.5 239.22V236.72H254V184.223H256.5C271.567 184.223 283.922 182.736 292.495 181.253C296.781 180.512 300.119 179.773 302.376 179.222C303.504 178.946 304.361 178.718 304.931 178.56C305.216 178.481 305.43 178.42 305.569 178.379C305.638 178.359 305.689 178.344 305.722 178.334L305.756 178.323L305.762 178.322L305.763 178.321L308.997 177.326ZM259 234.155C284.02 232.855 303.997 212.151 303.997 186.723V183.972C303.857 184.007 303.711 184.042 303.562 184.079C301.203 184.655 297.753 185.418 293.347 186.18C285.018 187.621 273.264 189.057 259 189.209V234.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 131.215V186.723C286.959 186.723 306.497 180.711 306.497 180.711V131.215H256.5Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254 128.715H308.997V182.558L307.233 183.101L306.497 180.711C307.233 183.101 307.232 183.101 307.231 183.101L307.225 183.103L307.21 183.107L307.159 183.123C307.116 183.136 307.053 183.154 306.972 183.178C306.811 183.225 306.574 183.293 306.266 183.379C305.648 183.55 304.741 183.791 303.562 184.079C301.203 184.655 297.753 185.419 293.347 186.18C284.536 187.704 271.893 189.223 256.5 189.223H254V128.715ZM303.997 178.812V133.715H259V184.209C272.936 184.057 284.401 182.653 292.495 181.253C296.781 180.512 300.119 179.773 302.376 179.222C303 179.069 303.542 178.931 303.997 178.812Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 0.960693)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDo);
export default __webpack_public_path__ + "static/media/DO.88ad92dd14ea3e622476f6556c72b8fc.svg";
export { ForwardRef as ReactComponent };